import React from "react";
import { initKakao, loginWithKakao } from "../auth/kakao";
import { kakaoLogin } from "../api/authApi";

initKakao();

export default function KakaoLoginButton() {
  const login = () => {
     window.location.href = "/api/auth/kakao/login";
  };

  return (
    <button onClick={login}>
      카카오 로그인
    </button>
  );
}
